/**
 *
 */
export default {
  name: 'KDataGridCell',
  props: {
    rowIndex: {
      type: Number,
      default: -1,
    },
    colIndex: {
      type: Number,
      default: -1,
    },
    hoverCell: {
      type: Object,
      default() {
        return null
      },
    },
    align: {
      type: String,
      default: '',
    },
    custom: { // 是否自定制
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      width: '',
      height: '',
    }
  },
  computed: {
    context() {
      let parent = this.$parent
      while (parent && !parent.dataGridId) {
        parent = parent.$parent
      }
      return parent
    },
    store() {
      return this.$parent.store
    },
    // border() {
    //   return this.context.border
    // },
    isHovered() {
      return this.hoverCell && this.hoverCell.rowIndex === this.rowIndex
    },
  },
  methods: {
    handleCellMouseEnter() {
      this.$emit('hoverCell', this)
    },
    handleCellMouseLeave() {
      this.$emit('hoverCell', null)
    },
  },
  mounted() {
  },
  render() {
    const style = {}

    const css = {
      'km-data-grid__cell': true,
      // 'km-data-grid__cell--border': this.border,
      'km-data-grid__cell--hovered': this.isHovered,
      'km-data-grid__cell--custom': this.custom,
    }

    const alignMeta = {
      left: '',
      center: 'center',
      right: 'end',
    }

    const align = alignMeta[this.align]

    if (align) {
      css['is-justify-' + align] = true
    }

    const attrs = {}

    const events = {
      mouseenter: this.handleCellMouseEnter,
      mouseleave: this.handleCellMouseLeave,
    }

    const data = {
      style: style,
      class: css,
      attrs: attrs,
      on: events,
    }

    return (
      <div {...data}>
        {this.$slots.default}
      </div>
    )
  },
}
